import { createFileRoute } from "@tanstack/react-router";
import { GeneratePlates } from "../../app/views/pcr/generatePlates";

export const Route = createFileRoute("/pcr/mapplates")({
  component: GeneratePlates,
});
